import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/Email';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SupportIcon from '@mui/icons-material/Support';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import useContact from '../../../../../hooks/providers/useContact';
import useProfile from '../../../../../hooks/providers/useProfile';
import HeaderSingleHelpRessource from '../HeaderSingleHelpRessource/HeaderSingleHelpRessource';

const primaryColor = import.meta.env.VITE_MAIN_COLOR;
const commonMenuItemStyle = {
  marginRight: 1,
  color: primaryColor,
  fontSize: '20px',
  display: 'flex',
  alignItems: 'flex-start',
  marginTop: '2px'
};

const HeaderHelpRessourcesList = () => {
  const {getHelpButtons} = useProfile();
  const {setIsContactFormOpen} = useContact();

  const getCategoryIcon = categoryItems => {
    const hasContactItem = categoryItems.some(item => item.src_iframe === 'contact');
    const hasCanvaItem = categoryItems.some(item => item.src_iframe === 'canva');
    const hasHubspotItem = categoryItems.some(item => item.src_iframe === 'hubspot');
    const hasFormsItem = categoryItems.some(item => item.src_iframe === 'forms');

    if (hasContactItem) {
      return <EmailIcon sx={commonMenuItemStyle} />;
    }
    if (hasCanvaItem) {
      return <SupportIcon sx={commonMenuItemStyle} />;
    }
    if (hasHubspotItem) {
      return <SupportAgentIcon sx={commonMenuItemStyle} />;
    }
    if (hasFormsItem) {
      return <DescriptionIcon sx={commonMenuItemStyle} />;
    }
    return <KeyboardArrowRightIcon sx={{marginLeft: '8px', color: primaryColor, fontSize: 'small'}} />;
  };

  if (!getHelpButtons) return null;
  const categories = Object.keys(getHelpButtons);

  return categories.map(category => {
    const items = getHelpButtons[category];
    const isContactCategory = items.some(item => item.src_iframe === 'contact');
    const icon = getCategoryIcon(items);

    const ressource = {
      id: category,
      title: category,
      links: items,
      icon
    };

    return (
      <HeaderSingleHelpRessource
        key={category}
        ressource={ressource}
        hasExpandButton={!isContactCategory}
        onCategoryClick={() => {
          if (isContactCategory) {
            setIsContactFormOpen(true);
          }
        }}
      />
    );
  });
};

export default HeaderHelpRessourcesList;
